import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    date: {
        id: '_.funding_history.date',
        defaultMessage: 'Date'
    },
    fundedAmount: {
        id: '_.funding_history.funded_amount',
        defaultMessage: 'Funded amount'
    },
    drawdownFee: {
        id: '_.funding_history.drawdown_fee',
        defaultMessage: 'Drawdown fee'
    },
    interestRate: {
        id: '_.funding_history.interest_rate',
        defaultMessage: 'Interest rate'
    },
    duration: {
        id: '_.funding_history.duration',
        defaultMessage: 'Duration (months)'
    },

    maxCreditLimit: {
        id: '_.funding_history.max_credit_limit',
        defaultMessage: 'Max credit limit'
    },

    principalAfterFunding: {
        id: '_.funding_history.principal_after_funding',
        defaultMessage: 'Principal after funding'
    },
    offerWindow: {
        id: '_.funding_history.offer_window_days',
        defaultMessage: 'Offer window (days)'
    },
    interestOnlyPeriod: {
        id: '_.funding_history.interest_only_period',
        defaultMessage: 'Interest only period (months)'
    }
});
